import { useState } from "react";
import { IconButton, Popover } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { addDays, formatTurkishDate, localDateString, parseLocalDate } from "../../../lib/dateUtils";
import { useScriptMode } from "../../../contexts/ScriptModeContext";

export default function DateNavigator({ value, onChange }) {
  const { t } = useScriptMode();
  const date = parseLocalDate(value) || new Date();
  const [anchor, setAnchor] = useState(null);

  const change = (newDate) => onChange(localDateString(newDate));

  return (
    <div className="flex items-center gap-2">
      <IconButton onClick={() => change(addDays(date, -1))} aria-label={t("day_prev")}>
        <ChevronLeftIcon />
      </IconButton>
      <button
        type="button"
        onClick={(e) => setAnchor(e.currentTarget)}
        className="text-lg font-SemiBold text-terakkiPrimary px-3 py-1 rounded hover:bg-terakkiSurfaceAlt flex items-center gap-2"
      >
        <CalendarTodayIcon fontSize="small" />
        {formatTurkishDate(date)}
      </button>
      <IconButton onClick={() => change(addDays(date, 1))} aria-label={t("day_next")}>
        <ChevronRightIcon />
      </IconButton>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <input
          type="date"
          value={localDateString(date)}
          onChange={(e) => {
            const d = parseLocalDate(e.target.value);
            if (d) {
              onChange(e.target.value);
              setAnchor(null);
            }
          }}
          className="p-3 outline-none"
        />
      </Popover>
    </div>
  );
}
